import { FieldSelectMulti } from '@looker/components';

import { useMe } from '@/hooks/use-me';
import { plural } from '@/utils/format/label';

import { useSiteMapFilters } from '../hooks/use-filters';
import { useSiteIdsList } from '../hooks/use-site-ids-list';

export function SiteMapFilters() {
  const me = useMe();
  const [{ siteIds: selectedSiteIds = [] }, queryParams] = useSiteMapFilters();
  const siteIdsList = useSiteIdsList();
  const siteIds = siteIdsList.data ?? [];

  function handleUpdateSites(siteIds: string[] = []) {
    queryParams.replace({ siteIds: siteIds.length > 0 ? siteIds : undefined });
  }

  return (
    <div className="size-full gap-4 border-b border-gray-100 bg-white p-4 xl:px-[3.75rem] xl:pb-4 xl:pt-5">
      <FieldSelectMulti
        className="mb-4 max-h-[38px] w-full max-w-[400px]"
        options={siteIdsList.data?.map((value) => ({ value }))}
        values={selectedSiteIds}
        label={plural(me.config.group.labels.name)}
        placeholder={
          selectedSiteIds?.length > 0
            ? ''
            : siteIds.length === 0
              ? plural(me.config.group.labels.name)
              : `${siteIds.slice(0, 2).join(', ')}...`
        }
        isLoading={siteIdsList.isLoading}
        onChange={handleUpdateSites}
      />
    </div>
  );
}
